export default __webpack_public_path__ + "static/media/buying-thumb-v1.8f73f588.webp";